import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { getProjects } from '../api';
import { useAuth } from '../AuthContext';

export default function Dashboard() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getProjects()
      .then((r) => setProjects(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const active = projects.filter((p) => p.status === 'active').length;

  return (
    <Layout title="Dashboard">
      <div className="page-header">
        <div className="page-header-text">
          <h1>Welcome back</h1>
          <p>{user?.email} · Admin</p>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/projects')}>
          + New Project
        </button>
      </div>

      <div className="grid-4" style={{ marginBottom: 28 }}>
        <div className="stat-card">
          <div className="stat-label">Total Projects</div>
          <div className="stat-value">{projects.length}</div>
          <div className="stat-sub">All time</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Active Projects</div>
          <div className="stat-value" style={{ color: 'var(--accent)' }}>{active}</div>
          <div className="stat-sub">Accepting submissions</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Disabled</div>
          <div className="stat-value">{projects.length - active}</div>
          <div className="stat-sub">Closed projects</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">System</div>
          <div className="stat-value" style={{ color: 'var(--accent)', fontSize: '1rem', paddingTop: 4 }}>✓ OK</div>
          <div className="stat-sub">Backend connected</div>
        </div>
      </div>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ fontSize: '0.95rem', fontWeight: 600 }}>Recent Projects</h2>
          <button className="btn btn-ghost btn-sm" onClick={() => navigate('/projects')}>View all →</button>
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}>
            <div className="spinner spinner-lg" />
          </div>
        ) : projects.length === 0 ? (
          <div className="empty-state">
            <span style={{ fontSize: 32 }}>⊞</span>
            <h3>No projects yet</h3>
            <p>Create your first project to start generating student ID cards.</p>
            <button className="btn btn-primary" onClick={() => navigate('/projects')}>Create Project</button>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {projects.slice(0, 8).map((p) => (
                  <tr key={p.id}>
                    <td className="td-primary">{p.name}</td>
                    <td>
                      <span className={`badge ${p.status === 'active' ? 'badge-green' : 'badge-gray'}`}>
                        {p.status}
                      </span>
                    </td>
                    <td className="td-mono">{new Date(p.created_at).toLocaleDateString()}</td>
                    <td>
                      <button className="btn btn-ghost btn-sm" onClick={() => navigate(`/projects/${p.id}`)}>
                        Open →
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
